import Select from 'react-select'
import { FormikProps } from 'formik'
import { InitialState as SurveyInitialState } from 'Store/Survey'
import { SURVEY_STATUS_OPTIONS } from '../../../../../Configuration/Paco'
import clsx from 'clsx'

interface Props {
  isView?: boolean
  formik: FormikProps<SurveyInitialState>
}
const statusOptions = SURVEY_STATUS_OPTIONS.map(item => ({
  label: `${item.key.substring(0, 1).toUpperCase()}${item.key.substring(1).toLowerCase()} - ${
    item.title
  }`,
  value: item.key,
}))
const FinancialRisk: React.FC<Props> = ({ isView, formik }) => {
  return (
    <div className='card'>
      <div className='card-header'>
        <div className='card-title fw-bold'>
          ส่วนที่ 3 - ความเสี่ยงด้านการเงินหรือด้านอื่นๆเพิ่มเติม
        </div>
      </div>

      <div className='card-body'>
        <div className='row gy-5'>
          <div className='col-12'>
            <label className='form-label mb-5'>Safety Request (Optional)</label>

            <textarea
              name='safetyRequest'
              className='form-control form-control-sm'
              rows={10}
              value={formik.values.safetyRequest}
              onChange={(e: any) => {
                formik.setFieldValue('safetyRequest', e.target.value)
              }}
              disabled={isView}
            />
          </div>

          <div className='col-12'>
            <label className='form-label mb-5'>สถานะงาน</label>
            <Select
              isClearable={false}
              isMulti={false}
              isDisabled={isView}
              options={statusOptions}
              value={statusOptions.find(item => item.value === formik.values.jobStatus) ?? ''}
              onChange={(item: any) => formik.setFieldValue('jobStatus', item?.value)}
              className={clsx({
                'is-invalid': formik.touched.jobStatus && formik.errors.jobStatus,
              })}
            />
            {formik.touched.jobStatus && formik.errors.jobStatus && (
              <div className='invalid-feedback' style={{ fontSize: '14px', fontWeight: '500' }}>
                {formik.errors.jobStatus}
              </div>
            )}
          </div>

          <div className='col-12'>
            <label className='form-label mb-5'>ความเสี่ยงด้านการเงิน (Optional)</label>

            <textarea
              name='noteRiskFinancial'
              className='form-control form-control-sm'
              rows={10}
              value={formik.values.noteRiskFinancial}
              onChange={(e: any) => {
                formik.setFieldValue('noteRiskFinancial', e.target.value)
              }}
              disabled={isView}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default FinancialRisk
